import { useSearchParams, useNavigate } from "react-router-dom";
import { useResetPassword } from "../hooks/useResetPassword";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FiLock } from "react-icons/fi";
import AuthShell, { authInputCls, authPrimaryBtn } from "../Components/AuthShell";


const ResetPassword = () => {

  const { sendResetPassReq, verifyToken } = useResetPassword()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const [mssg, setmsg] = useState("");
  const [succ, setSucc] = useState("");
  const [pass, setPass] = useState("");
  const[err,setErr] = useState("");
  const [password, setVerifyPass] = useState("");
  const emailToken = searchParams.get("emailToken");
  // const email = searchParams.get("email");

  useEffect(() => {

    if (searchParams.size === 0) {
      return navigate("/login")
    }
    if (emailToken === null) {
      return navigate("/login")
    }
    const checkToken = async () => {
      const check = await verifyToken(emailToken)
      if (check.status === 400) {
        return navigate("/login")
      }
    }
    checkToken()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

//send password and reset
  const handleResetPassword = async (e) => {
    e.preventDefault()


    if (pass !== password) {
      setmsg("Password and Verify Password should be same")

    } else {
      setmsg("")
    
      const response = await sendResetPassReq( emailToken, password)
      const json = await response.json()
      if(!response.ok){
        setErr(json.error)
    } 
    if(response.ok){
      setSucc("Password Successfully Reset! Redirecting.....")
      setTimeout(() => {
            navigate("/login")
          }, 2000);
    }
  
    
    }
   
   






  }



  return (
    <AuthShell>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Password Reset - Content Flash AI</title>
        <meta name="description" content="Reset your Content Flash AI password." />
      </Helmet>

      <h2 className="text-2xl font-bold text-gray-900">Set a new password</h2>
      <p className="text-sm text-gray-500 mt-1">Choose a strong password for your account.</p>

      <form className="space-y-4 mt-6" onSubmit={handleResetPassword}>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">New password</label>
          <div className="relative">
            <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input type="password" placeholder="••••••••" className={authInputCls} onChange={(e) => setPass(e.target.value)} />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Confirm password</label>
          <div className="relative">
            <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input type="password" placeholder="••••••••" className={authInputCls} onChange={(e) => setVerifyPass(e.target.value)} />
          </div>
        </div>

        {mssg && <p className="text-sm text-center text-red-600 font-medium">{mssg}</p>}
        {err && <p className="text-sm text-center text-red-600 font-medium">{err}</p>}
        {succ && <p className="text-sm text-center text-green-600 font-medium">{succ}</p>}

        <button className={authPrimaryBtn}>Reset password</button>
      </form>
    </AuthShell>
  )

}

export default ResetPassword;







